import {
  SupportedMediaType,
  TokenMetadataAttribute,
  _CollectionType,
} from "apollo/graphql.generated";
import { CollectionAttributeFormValues } from "~/features/collections/forms/CreateCollectionMultistepForm/AddMetadataTraitsModal";

import EditEditionMetadataModal from "./EditEditionMetadataModal";
import EditSeriesMetadataModal from "./EditSeriesMetadataModal";

export interface EditMetadataFormValues {
  name: string;
  description: string;
  traits: CollectionAttributeFormValues[];
  mediaUrl: string;
  mediaType: SupportedMediaType;
  coverMediaUrl: string | null;
  autoAddCollectionNameAsTrait: boolean;
}

export const EditMetadataModal = ({
  collectionId,
  currentName,
  currentDescription,
  attributes,
  onClose,
  currentMediaUrl,
  currentAnimationUrl,
  chainId,
  collectionType,
  metadataIsDecentralized,
  reveal,
  takenIds,
  collectionSize,
}: EditMetadataModalProps) => {
  if (collectionType === _CollectionType.Series) {
    return (
      <EditSeriesMetadataModal
        onClose={onClose}
        hasPendingUpdate={false}
        metadataIsDecentralized={metadataIsDecentralized}
        takenIds={takenIds}
        reveal={reveal}
        chainId={chainId}
        collectionId={collectionId}
        collectionSize={collectionSize}
        collectionType={collectionType}
      />
    );
  } else {
    return (
      <EditEditionMetadataModal
        collectionId={collectionId}
        collectionType={collectionType}
        currentMediaUrl={currentMediaUrl}
        currentAnimationUrl={currentAnimationUrl}
        currentName={currentName}
        currentDescription={currentDescription}
        attributes={attributes}
        onClose={onClose}
        chainId={chainId}
      />
    );
  }
};

export interface EditMetadataModalProps {
  collectionId: string;
  collectionType: _CollectionType;
  currentName: string;
  currentDescription: string;
  seriesImageUrls?: string[];
  attributes: TokenMetadataAttribute[];
  currentMediaUrl: string;
  currentAnimationUrl: string | null;
  onClose: () => void;
  chainId: number;
  metadataIsDecentralized: boolean;
  reveal: boolean;
  takenIds?: number[];
  collectionSize: number;
}
